var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pvp-tooltip',[_c('button',{staticClass:"rewards-id",on:{"click":function($event){return _vm.copyText(_vm.id)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('template',{slot:"tooltip"},[_vm._v(" "+_vm._s(_vm.isCopied ? _vm.$t('global.copied') : _vm.$t('global.copy'))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }